import React, { Component } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import "./styles.css";
import store from "../../config/store";
import { logout } from "../../actions/user";
import { withRouter } from "react-router-dom";

class NavTop extends Component {
  onLogout = () => {
    store.dispatch(logout());
    this.props.history.push("/home");
  };

  render() {
    return (
      <div className="nav-top">
        <div>
          <NavLink to="/journal" activeclassname="active">
            Дневник
          </NavLink>
        </div>
        <div>
          <NavLink to="/profile" activeclassname="active">
            Профил
          </NavLink>
        </div>
        <div className="item-logout">
          <Link to="/">
            <span className="txt" onClick={this.onLogout}>
              Излез
            </span>
            <span className="icon-logout" onClick={this.onLogout}/>
          </Link>
        </div>
      </div>
    );
  }
}

export default withRouter(NavTop);



// WEBPACK FOOTER //
// ./src/components/NavTop/NavTop.js